import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-file-video",
  "use": "icon-file-video-usage",
  "viewBox": "0 0 48 48",
  "content": "<symbol viewBox=\"0 0 48 48\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-file-video\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M30.7567 0.498485L42.1688 11.9106C42.487 12.2288 42.6673 12.6636 42.6673 13.1144V45.8182C42.6673 46.7568 41.909 47.5152 40.9704 47.5152H7.03095C6.09232 47.5152 5.33398 46.7568 5.33398 45.8182V1.69697C5.33398 0.758333 6.09232 0 7.03095 0H29.5582C30.009 0 30.4385 0.180303 30.7567 0.498485ZM38.7537 13.8939L28.7734 3.91364V13.8939H38.7537ZM9.15217 43.697H38.8491V17.5H27.3946C26.8039 17.5 26.2374 17.2653 25.8197 16.8476C25.402 16.43 25.1673 15.8634 25.1673 15.2727V3.81818H9.15217V43.697ZM20.6181 24.2465C19.9514 23.8616 19.1181 24.3427 19.1181 25.1125V36.018C19.1181 36.7878 19.9515 37.269 20.6181 36.8841L30.0626 31.4313C30.7292 31.0464 30.7292 30.0842 30.0626 29.6993L20.6181 24.2465Z\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/file-video.svg
// module id = ST7c
// module chunks = 6 7